export default __webpack_public_path__ + "static/media/Raider's Boots of the Howling Moon.2875167a.jpg";